import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";
import appStyles from "../../../appStyles";

export default function ArrowRightIcon(props) {
  const { style, onPress = () => {}, fillColor = "#2D3142" } = props;
  const width = props.width || 12;
  const height = props.height || 12;

  return (
    <TouchableOpacity
      style={[appStyles.iconContainer, style]}
      onPress={onPress}
    >
      <Svg
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.73579 6L3.20065 10.7619C2.90114 11.0764 2.9416 11.5499 3.29104 11.8194C3.64048 12.089 4.16656 12.0526 4.46608 11.7381L9.46607 6.48809C9.73356 6.20723 9.73356 5.79277 9.46607 5.51191L4.46608 0.261919C4.16656 -0.0525742 3.64048 -0.0889953 3.29104 0.180571C2.9416 0.450137 2.90114 0.923611 3.20065 1.2381L7.73579 6Z"
          fill={fillColor}
        />
      </Svg>
    </TouchableOpacity>
  );
}
